import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class WfCurrentComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentWfCurrent | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.disabled = settings?.disabled ?? null;
		this.input = true;
		this.kdata = {
			submit: null,
			...settings?.kdata,
		};
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'wf_kid',
			'wfstate_kid',
			'wfallocatorlist',
			'wfcomment',
			'action',
		]);
	}
}
